import { RemoteDocuments } from "../../../../data/usecases/documents/remote-documents";
import { Documents } from "../../../../domain/models/documents";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteDocument = (): Documents =>
  new RemoteDocuments("/documents-emission", makeAxiosHttpClient());
